<template>
    <div :class="{ circles: true, [color]: true }">
        <div class="circle"></div>
        <div class="circle small"></div>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_circles.scss
</style>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: ''
            }
        }
    };
</script>
